"use strict";

// source: spine/server/delivery/delivery.proto

/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
var jspb = require('google-protobuf');

var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');

goog.object.extend(proto, spine_options_pb);

var google_protobuf_timestamp_pb = require('../../../google/protobuf/timestamp_pb.js');

goog.object.extend(proto, google_protobuf_timestamp_pb);

var spine_server_server_environment_pb = require('../../../spine/server/server_environment_pb.js');

goog.object.extend(proto, spine_server_server_environment_pb);
goog.exportSymbol('proto.spine.server.delivery.DeliveryStage', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardIndex', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardMaintenance', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardSessionRecord', null, global);
goog.exportSymbol('proto.spine.server.delivery.WorkerId', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */

proto.spine.server.delivery.ShardIndex = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.server.delivery.ShardIndex, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.server.delivery.ShardIndex.displayName = 'proto.spine.server.delivery.ShardIndex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.server.delivery.ShardSessionRecord = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.server.delivery.ShardSessionRecord, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.server.delivery.ShardSessionRecord.displayName = 'proto.spine.server.delivery.ShardSessionRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.server.delivery.DeliveryStage = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.server.delivery.DeliveryStage, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.server.delivery.DeliveryStage.displayName = 'proto.spine.server.delivery.DeliveryStage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.server.delivery.ShardMaintenance = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.server.delivery.ShardMaintenance, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.server.delivery.ShardMaintenance.displayName = 'proto.spine.server.delivery.ShardMaintenance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */


proto.spine.server.delivery.WorkerId = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};

goog.inherits(proto.spine.server.delivery.WorkerId, jspb.Message);

if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.spine.server.delivery.WorkerId.displayName = 'proto.spine.server.delivery.WorkerId';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.server.delivery.ShardIndex.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.server.delivery.ShardIndex.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.server.delivery.ShardIndex} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.server.delivery.ShardIndex.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      index: jspb.Message.getFieldWithDefault(msg, 1, 0),
      ofTotal: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardIndex}
 */


proto.spine.server.delivery.ShardIndex.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardIndex();
  return proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardIndex}
 */


proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setIndex(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setOfTotal(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.server.delivery.ShardIndex.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIndex();

  if (f !== 0) {
    writer.writeInt32(1, f);
  }

  f = message.getOfTotal();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional int32 index = 1;
 * @return {number}
 */


proto.spine.server.delivery.ShardIndex.prototype.getIndex = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 1, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.spine.server.delivery.ShardIndex} returns this
 */


proto.spine.server.delivery.ShardIndex.prototype.setIndex = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 of_total = 2;
 * @return {number}
 */


proto.spine.server.delivery.ShardIndex.prototype.getOfTotal = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.spine.server.delivery.ShardIndex} returns this
 */


proto.spine.server.delivery.ShardIndex.prototype.setOfTotal = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.server.delivery.ShardSessionRecord.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.server.delivery.ShardSessionRecord.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.server.delivery.ShardSessionRecord} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.server.delivery.ShardSessionRecord.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      index: (f = msg.getIndex()) && proto.spine.server.delivery.ShardIndex.toObject(includeInstance, f),
      whenLastPicked: (f = msg.getWhenLastPicked()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      worker: (f = msg.getWorker()) && proto.spine.server.delivery.WorkerId.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardSessionRecord}
 */


proto.spine.server.delivery.ShardSessionRecord.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardSessionRecord();
  return proto.spine.server.delivery.ShardSessionRecord.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardSessionRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardSessionRecord}
 */


proto.spine.server.delivery.ShardSessionRecord.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.spine.server.delivery.ShardIndex();
        reader.readMessage(value, proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader);
        msg.setIndex(value);
        break;

      case 3:
        var value = new google_protobuf_timestamp_pb.Timestamp();
        reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setWhenLastPicked(value);
        break;

      case 4:
        var value = new proto.spine.server.delivery.WorkerId();
        reader.readMessage(value, proto.spine.server.delivery.WorkerId.deserializeBinaryFromReader);
        msg.setWorker(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardSessionRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardSessionRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.server.delivery.ShardSessionRecord.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIndex();

  if (f != null) {
    writer.writeMessage(1, f, proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter);
  }

  f = message.getWhenLastPicked();

  if (f != null) {
    writer.writeMessage(3, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }

  f = message.getWorker();

  if (f != null) {
    writer.writeMessage(4, f, proto.spine.server.delivery.WorkerId.serializeBinaryToWriter);
  }
};
/**
 * optional ShardIndex index = 1;
 * @return {?proto.spine.server.delivery.ShardIndex}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.getIndex = function () {
  return (
    /** @type{?proto.spine.server.delivery.ShardIndex} */
    jspb.Message.getWrapperField(this, proto.spine.server.delivery.ShardIndex, 1)
  );
};
/**
 * @param {?proto.spine.server.delivery.ShardIndex|undefined} value
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
*/


proto.spine.server.delivery.ShardSessionRecord.prototype.setIndex = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.clearIndex = function () {
  return this.setIndex(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.hasIndex = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional google.protobuf.Timestamp when_last_picked = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.getWhenLastPicked = function () {
  return (
    /** @type{?proto.google.protobuf.Timestamp} */
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3)
  );
};
/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
*/


proto.spine.server.delivery.ShardSessionRecord.prototype.setWhenLastPicked = function (value) {
  return jspb.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.clearWhenLastPicked = function () {
  return this.setWhenLastPicked(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.hasWhenLastPicked = function () {
  return jspb.Message.getField(this, 3) != null;
};
/**
 * optional WorkerId worker = 4;
 * @return {?proto.spine.server.delivery.WorkerId}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.getWorker = function () {
  return (
    /** @type{?proto.spine.server.delivery.WorkerId} */
    jspb.Message.getWrapperField(this, proto.spine.server.delivery.WorkerId, 4)
  );
};
/**
 * @param {?proto.spine.server.delivery.WorkerId|undefined} value
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
*/


proto.spine.server.delivery.ShardSessionRecord.prototype.setWorker = function (value) {
  return jspb.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.ShardSessionRecord} returns this
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.clearWorker = function () {
  return this.setWorker(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.ShardSessionRecord.prototype.hasWorker = function () {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.server.delivery.DeliveryStage.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.server.delivery.DeliveryStage.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.server.delivery.DeliveryStage} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.server.delivery.DeliveryStage.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      index: (f = msg.getIndex()) && proto.spine.server.delivery.ShardIndex.toObject(includeInstance, f),
      messagesdelivered: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.DeliveryStage}
 */


proto.spine.server.delivery.DeliveryStage.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.DeliveryStage();
  return proto.spine.server.delivery.DeliveryStage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.DeliveryStage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.DeliveryStage}
 */


proto.spine.server.delivery.DeliveryStage.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.spine.server.delivery.ShardIndex();
        reader.readMessage(value, proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader);
        msg.setIndex(value);
        break;

      case 2:
        var value =
        /** @type {number} */
        reader.readInt32();
        msg.setMessagesdelivered(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.server.delivery.DeliveryStage.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.DeliveryStage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.DeliveryStage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.server.delivery.DeliveryStage.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getIndex();

  if (f != null) {
    writer.writeMessage(1, f, proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter);
  }

  f = message.getMessagesdelivered();

  if (f !== 0) {
    writer.writeInt32(2, f);
  }
};
/**
 * optional ShardIndex index = 1;
 * @return {?proto.spine.server.delivery.ShardIndex}
 */


proto.spine.server.delivery.DeliveryStage.prototype.getIndex = function () {
  return (
    /** @type{?proto.spine.server.delivery.ShardIndex} */
    jspb.Message.getWrapperField(this, proto.spine.server.delivery.ShardIndex, 1)
  );
};
/**
 * @param {?proto.spine.server.delivery.ShardIndex|undefined} value
 * @return {!proto.spine.server.delivery.DeliveryStage} returns this
*/


proto.spine.server.delivery.DeliveryStage.prototype.setIndex = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.DeliveryStage} returns this
 */


proto.spine.server.delivery.DeliveryStage.prototype.clearIndex = function () {
  return this.setIndex(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.DeliveryStage.prototype.hasIndex = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional int32 messagesDelivered = 2;
 * @return {number}
 */


proto.spine.server.delivery.DeliveryStage.prototype.getMessagesdelivered = function () {
  return (
    /** @type {number} */
    jspb.Message.getFieldWithDefault(this, 2, 0)
  );
};
/**
 * @param {number} value
 * @return {!proto.spine.server.delivery.DeliveryStage} returns this
 */


proto.spine.server.delivery.DeliveryStage.prototype.setMessagesdelivered = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.server.delivery.ShardMaintenance.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.server.delivery.ShardMaintenance.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.server.delivery.ShardMaintenance} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.server.delivery.ShardMaintenance.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      id: (f = msg.getId()) && proto.spine.server.delivery.ShardIndex.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardMaintenance}
 */


proto.spine.server.delivery.ShardMaintenance.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardMaintenance();
  return proto.spine.server.delivery.ShardMaintenance.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardMaintenance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardMaintenance}
 */


proto.spine.server.delivery.ShardMaintenance.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new proto.spine.server.delivery.ShardIndex();
        reader.readMessage(value, proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader);
        msg.setId(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.server.delivery.ShardMaintenance.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardMaintenance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardMaintenance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.server.delivery.ShardMaintenance.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getId();

  if (f != null) {
    writer.writeMessage(1, f, proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter);
  }
};
/**
 * optional ShardIndex id = 1;
 * @return {?proto.spine.server.delivery.ShardIndex}
 */


proto.spine.server.delivery.ShardMaintenance.prototype.getId = function () {
  return (
    /** @type{?proto.spine.server.delivery.ShardIndex} */
    jspb.Message.getWrapperField(this, proto.spine.server.delivery.ShardIndex, 1)
  );
};
/**
 * @param {?proto.spine.server.delivery.ShardIndex|undefined} value
 * @return {!proto.spine.server.delivery.ShardMaintenance} returns this
*/


proto.spine.server.delivery.ShardMaintenance.prototype.setId = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.ShardMaintenance} returns this
 */


proto.spine.server.delivery.ShardMaintenance.prototype.clearId = function () {
  return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.ShardMaintenance.prototype.hasId = function () {
  return jspb.Message.getField(this, 1) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.spine.server.delivery.WorkerId.prototype.toObject = function (opt_includeInstance) {
    return proto.spine.server.delivery.WorkerId.toObject(opt_includeInstance, this);
  };
  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.spine.server.delivery.WorkerId} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */


  proto.spine.server.delivery.WorkerId.toObject = function (includeInstance, msg) {
    var f,
        obj = {
      nodeid: (f = msg.getNodeid()) && spine_server_server_environment_pb.NodeId.toObject(includeInstance, f),
      value: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }

    return obj;
  };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.WorkerId}
 */


proto.spine.server.delivery.WorkerId.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.WorkerId();
  return proto.spine.server.delivery.WorkerId.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.WorkerId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.WorkerId}
 */


proto.spine.server.delivery.WorkerId.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }

    var field = reader.getFieldNumber();

    switch (field) {
      case 1:
        var value = new spine_server_server_environment_pb.NodeId();
        reader.readMessage(value, spine_server_server_environment_pb.NodeId.deserializeBinaryFromReader);
        msg.setNodeid(value);
        break;

      case 2:
        var value =
        /** @type {string} */
        reader.readString();
        msg.setValue(value);
        break;

      default:
        reader.skipField();
        break;
    }
  }

  return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */


proto.spine.server.delivery.WorkerId.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.WorkerId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.WorkerId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */


proto.spine.server.delivery.WorkerId.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getNodeid();

  if (f != null) {
    writer.writeMessage(1, f, spine_server_server_environment_pb.NodeId.serializeBinaryToWriter);
  }

  f = message.getValue();

  if (f.length > 0) {
    writer.writeString(2, f);
  }
};
/**
 * optional spine.server.NodeId nodeId = 1;
 * @return {?proto.spine.server.NodeId}
 */


proto.spine.server.delivery.WorkerId.prototype.getNodeid = function () {
  return (
    /** @type{?proto.spine.server.NodeId} */
    jspb.Message.getWrapperField(this, spine_server_server_environment_pb.NodeId, 1)
  );
};
/**
 * @param {?proto.spine.server.NodeId|undefined} value
 * @return {!proto.spine.server.delivery.WorkerId} returns this
*/


proto.spine.server.delivery.WorkerId.prototype.setNodeid = function (value) {
  return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spine.server.delivery.WorkerId} returns this
 */


proto.spine.server.delivery.WorkerId.prototype.clearNodeid = function () {
  return this.setNodeid(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */


proto.spine.server.delivery.WorkerId.prototype.hasNodeid = function () {
  return jspb.Message.getField(this, 1) != null;
};
/**
 * optional string value = 2;
 * @return {string}
 */


proto.spine.server.delivery.WorkerId.prototype.getValue = function () {
  return (
    /** @type {string} */
    jspb.Message.getFieldWithDefault(this, 2, "")
  );
};
/**
 * @param {string} value
 * @return {!proto.spine.server.delivery.WorkerId} returns this
 */


proto.spine.server.delivery.WorkerId.prototype.setValue = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

goog.object.extend(exports, proto.spine.server.delivery); // Generated by Spine ProtoJs Plugin

var ObjectParser = require('../../../../client/parser/object-parser.js')["default"];

var TypeParsers = require('../../../../client/parser/type-parsers.js')["default"];

proto.spine.server.delivery.ShardIndex.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.server.delivery.ShardIndex.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.server.delivery.ShardIndex.Parser.prototype.constructor = proto.spine.server.delivery.ShardIndex.Parser;

proto.spine.server.delivery.ShardIndex.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.server.delivery.ShardIndex();

  if (obj.index !== undefined) {
    if (obj.index !== null) {
      var value = obj.index;
      msg.setIndex(value);
    }
  }

  if (obj.ofTotal !== undefined) {
    if (obj.ofTotal !== null) {
      var _value = obj.ofTotal;
      msg.setOfTotal(_value);
    }
  }

  return msg;
};

proto.spine.server.delivery.ShardSessionRecord.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.server.delivery.ShardSessionRecord.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.server.delivery.ShardSessionRecord.Parser.prototype.constructor = proto.spine.server.delivery.ShardSessionRecord.Parser;

proto.spine.server.delivery.ShardSessionRecord.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.server.delivery.ShardSessionRecord();

  if (obj.index !== undefined) {
    if (obj.index === null) {
      msg.setIndex(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.server.delivery.ShardIndex').fromObject(obj.index);
      msg.setIndex(value);
    }
  }

  if (obj.whenLastPicked !== undefined) {
    if (obj.whenLastPicked === null) {
      msg.setWhenLastPicked(null);
    } else {
      var _value2 = TypeParsers.parserFor('type.googleapis.com/google.protobuf.Timestamp').fromObject(obj.whenLastPicked);

      msg.setWhenLastPicked(_value2);
    }
  }

  if (obj.worker !== undefined) {
    if (obj.worker === null) {
      msg.setWorker(null);
    } else {
      var _value3 = TypeParsers.parserFor('type.spine.io/spine.server.delivery.WorkerId').fromObject(obj.worker);

      msg.setWorker(_value3);
    }
  }

  return msg;
};

proto.spine.server.delivery.ShardMaintenance.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.server.delivery.ShardMaintenance.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.server.delivery.ShardMaintenance.Parser.prototype.constructor = proto.spine.server.delivery.ShardMaintenance.Parser;

proto.spine.server.delivery.ShardMaintenance.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.server.delivery.ShardMaintenance();

  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.server.delivery.ShardIndex').fromObject(obj.id);
      msg.setId(value);
    }
  }

  return msg;
};

proto.spine.server.delivery.DeliveryStage.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.server.delivery.DeliveryStage.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.server.delivery.DeliveryStage.Parser.prototype.constructor = proto.spine.server.delivery.DeliveryStage.Parser;

proto.spine.server.delivery.DeliveryStage.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.server.delivery.DeliveryStage();

  if (obj.index !== undefined) {
    if (obj.index === null) {
      msg.setIndex(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.server.delivery.ShardIndex').fromObject(obj.index);
      msg.setIndex(value);
    }
  }

  if (obj.messagesDelivered !== undefined) {
    if (obj.messagesDelivered !== null) {
      var _value4 = obj.messagesDelivered;
      msg.setMessagesDelivered(_value4);
    }
  }

  return msg;
};

proto.spine.server.delivery.WorkerId.Parser = function () {
  ObjectParser.call(this);
};

proto.spine.server.delivery.WorkerId.Parser.prototype = Object.create(ObjectParser.prototype);
proto.spine.server.delivery.WorkerId.Parser.prototype.constructor = proto.spine.server.delivery.WorkerId.Parser;

proto.spine.server.delivery.WorkerId.Parser.prototype.fromObject = function (obj) {
  if (obj === null) {
    return null;
  }

  var msg = new proto.spine.server.delivery.WorkerId();

  if (obj.nodeId !== undefined) {
    if (obj.nodeId === null) {
      msg.setNodeId(null);
    } else {
      var value = TypeParsers.parserFor('type.spine.io/spine.server.NodeId').fromObject(obj.nodeId);
      msg.setNodeId(value);
    }
  }

  if (obj.value !== undefined) {
    if (obj.value !== null) {
      var _value5 = obj.value;
      msg.setValue(_value5);
    }
  }

  return msg;
}; // Generated by Spine ProtoJs Plugin


proto.spine.server.delivery.ShardIndex.typeUrl = function () {
  return 'type.spine.io/spine.server.delivery.ShardIndex';
}; // Generated by Spine ProtoJs Plugin


proto.spine.server.delivery.ShardSessionRecord.typeUrl = function () {
  return 'type.spine.io/spine.server.delivery.ShardSessionRecord';
}; // Generated by Spine ProtoJs Plugin


proto.spine.server.delivery.ShardMaintenance.typeUrl = function () {
  return 'type.spine.io/spine.server.delivery.ShardMaintenance';
}; // Generated by Spine ProtoJs Plugin


proto.spine.server.delivery.DeliveryStage.typeUrl = function () {
  return 'type.spine.io/spine.server.delivery.DeliveryStage';
}; // Generated by Spine ProtoJs Plugin


proto.spine.server.delivery.WorkerId.typeUrl = function () {
  return 'type.spine.io/spine.server.delivery.WorkerId';
};
//# sourceMappingURL=delivery_pb.js.map